import { render, staticRenderFns } from "./wbdp-pro-link-list.vue?vue&type=template&id=623e0ea4"
import script from "./wbdp-pro-link-list.vue?vue&type=script&lang=js"
export * from "./wbdp-pro-link-list.vue?vue&type=script&lang=js"
import style0 from "./wbdp-pro-link-list.vue?vue&type=style&index=0&id=623e0ea4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports